module.exports = __webpack_public_path__ + "static/media/faqBalance-en-fa.00f4ff2f.vtt";